module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center",
    attrs: {
      "id": "join-step"
    }
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('joinUs')))]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.$t('stepList')), function(step, index) {
    return _c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": '/static/img/affiliate/img_' + (index + 1) + '.png',
        "alt": ""
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('step')) + " " + _vm._s(index + 1))]), _vm._v(" "), _c('p', {
      staticClass: "little-title"
    }, [_vm._v(_vm._s(step.title))]), _vm._v(" "), _c('p', {
      staticClass: "describe"
    }, [_vm._v(_vm._s(step.detailDescribe))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d3114aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/affiliateProgram/joinStep/JoinStep.vue
// module id = 1330
// module chunks = 1